var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { log } from './log';
import { status } from './status';
import { getShouldLog } from './getShouldLog';
import { DEFAULTS } from './constants';
import { initIframeBridge } from './window';
import { permanentEnabler } from './permanent';
/**
 * Returns debugger Config for the debugger itself.
 * @returns Debugger Config
 */
const getInternalConfig = () => ({
    name: 'debugger',
    fColor: '#AAA',
    bColor: '#777',
});
initIframeBridge();
/**
 * Returns debug function based on config (name and colors)
 */
const debugFactory = (config) => {
    permanentEnabler();
    config = Object.assign({ fColor: DEFAULTS.FCOLOR, bColor: DEFAULTS.BCOLOR }, config);
    if (!(config && config.name && config.fColor && config.bColor)) {
        // in order not to break whomever is importing
        // return a function that can still be called
        return () => false;
    }
    const debug = (...args) => {
        const types = ['log', 'warn', 'error', 'info', 'table'];
        const argsCount = args.length;
        const shouldLog = getShouldLog(config.name);
        if (!shouldLog || argsCount === 0) {
            // nothing to log, just return shouldLog
            return shouldLog;
        }
        // debug({type: 'error', subName: '7845', message: 'Oh no', data: {...}, ...});
        // or debug({state: '...', ...})
        if (argsCount === 1 && typeof args[0] === 'object' && !Array.isArray(args[0]) && args[0] !== null) {
            const [firstArg] = args;
            const { state, type, subName, message } = firstArg, data = __rest(firstArg, ["state", "type", "subName", "message"]);
            if (shouldLog) {
                const logArgs = [];
                if (message !== undefined) {
                    logArgs.push(message);
                }
                if (Object.values(data).length === 1) {
                    logArgs.push(data[Object.keys(data)[0]]);
                }
                else if (Object.values(data).length) {
                    logArgs.push(data);
                }
                log(config, type, subName, ...logArgs);
            }
            if (state) {
                status(config, state, data);
            }
            return shouldLog;
        }
        // debug('Look what happens.');
        // debug(['someData', '...'}); anything else then object
        if (shouldLog && argsCount === 1) {
            log(config, 'log', undefined, args[0]);
            return shouldLog;
        }
        // debug('error', 'Oh no, there is an error.');   or other types, like warn, info, table...
        // debug('error', {someData: '...'});
        if (shouldLog && argsCount === 2 && ~types.indexOf(args[0])) {
            log(config, args[0], undefined, args[1]);
            return shouldLog;
        }
        // debug('Look at this data', data, [moreData, ...]);
        if (shouldLog && argsCount > 1 && !~types.indexOf(args[0])) {
            log(config, 'log', undefined, ...args);
            return shouldLog;
        }
        // debug('error', 'Oh no, there is an error, look at this data', data, [moreData, ...]);
        // debug('table', 'Look at this data', data);
        if (shouldLog && argsCount > 2 && ~types.indexOf(args[0])) {
            log(config, args[0], undefined, ...args.slice(1));
            return shouldLog;
        }
        // Some other args combination we forgot to cover? This shouldn't happen.
        log(getInternalConfig(), 'warn', undefined, 'Debugger received unknown argument combination. args:', args);
        return shouldLog;
    };
    return debug;
};
export { debugFactory, getInternalConfig };
